import { HttpClient } from '../interceptor';

export class StoreManagementApi{
    // 获取logo、slogan以及标题
    static getStoreList = () => {
        return new Promise(resolve => {
            HttpClient.post('/api/storeController/getStore', {}).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增门店
    static insertStore = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/storeController/addStore', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 编辑门店
    static updateStore = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/storeController/updateStore', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
}